import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { dateTimeFormat, dateFormat } from '../../helpers/timeFormat';
import { getRoleLabel, getBlockModeLabel } from '../../helpers/user';
import {
  Card,
  Button,
  Header,
  Label,
  Loader,
  Grid,
  Input,
  Icon,
  Confirm,
} from 'semantic-ui-react';
import { delegationActions } from '../../actions/delegation.actions';
import PropTypes from 'prop-types';
import { history } from '../../helpers';
import _ from 'lodash';
import { PaginationContainer } from '../../components/PaginationContainer';
import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";

class DelegationScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: null,
      users: null,
      confirmOpen: false,
      confirmAction: null,
      confirmUser: null,
      confirmMessage: null
    };
  }

  static get propTypes() {
    return {
      users: PropTypes.any,
      confirmOpen: PropTypes.bool,
      confirmAction: PropTypes.string,
      confirmMessage: PropTypes.string,
      confirmUser: PropTypes.any,
      loading: PropTypes.bool,
    };
  }

  componentDidMount() {
    this.handleSearchDebounced = _.debounce(function() {
      this.fetchDelegations();
    }, 500);

    this.fetchDelegations();
  }

  fetchDelegations(isExport) {
    const { dispatch } = this.props;
    const { page, search } = this.state;
    dispatch(delegationActions.fetch({ page, search, export: isExport ? true : null }));
  }

  exportXlsx() {
    this.fetchDelegations(true);
  }

  handleSearch(search) {
    this.setState({ search, page: 1 });
    this.handleSearchDebounced();
  }

  handlePageChange(activePage) {
    this.setState({ page: activePage }, () => this.fetchDelegations());
  }

  showConfirm(delegation, action) {
    const msg =  `Tem certeza que deseja remover a delegação ${delegation.Id} - ${delegation.Title}?`;
    this.setState({
      confirmOpen: true,
      confirmAction: action,
      confirmGroup: delegation,
      confirmMessage: msg
    });
  }

  closeConfirm() {
    this.setState({ confirmOpen: false});
  }

  executeConfirm() {
    const { dispatch } = this.props;
    const { confirmGroup, confirmAction } = this.state;
    if (confirmAction == 'remove') {
      dispatch(delegationActions.remove(confirmGroup.Id)).then(() => this.fetchDelegations());
    }
    setTimeout(() => this.fetchDelegations(), 1000);
    this.setState({
      confirmOpen: false,
      confirmAction: null,
      confirmGroup: null,
      confirmMessage: null
    });
  }

  goToCreate() {
    history.push('/delegation/create');
  }

  render() {
    const { loading, delegations, me } = this.props;
    
    // Check Permission
    if (me && me.permissions && !me.permissions.includes("delegation.fetch")) {
      window.location.href = "/";
      return;
    }
    
    return (
      <Fragment>
        <Loader active={loading}>Carregando...</Loader>
        <Confirm open={this.state.confirmOpen} content={this.state.confirmMessage} onCancel={() => this.closeConfirm()} onConfirm={() => this.executeConfirm()} />
        <Header>
          <h1>Delegações</h1>
        </Header>

        <Grid stackable columns='2'>
          <Grid.Row>
            <Grid.Column textAlign='left' width={10}>
              <Input icon='search' fluid onChange={(e, data) => this.handleSearch(data.value)} placeholder='Procurar...' loading={loading} />
            </Grid.Column>

            <Grid.Column width={3} textAlign='right'>
              <Button fluid onClick={() => this.exportXlsx()}><Icon name='file excel' /> Exportar</Button>              
            </Grid.Column>            

            <Grid.Column textAlign='right' width={3}>
              <Button color='primary' fluid onClick={this.goToCreate}>Nova Delegação</Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Card.Group>
          { (!delegations || (delegations.Results && delegations.TotalNumberOfRecords == 0)) &&
          <Card header='Nenhuma Delegação' fluid />
          }

          { delegations && delegations.Results && delegations.Results.map((delegation) => {
            return <Card key={delegation.Id} fluid>
              <Card.Content>
                <Card.Header>
                  #{delegation.Id} - {delegation.Title}
                </Card.Header>
                <Card.Description>
                  <p><strong>Usuário:</strong> {delegation.User.Name}</p>
                  <p><strong>Usuário Delegado:</strong> {delegation.DelegateUser.Name}</p>                  
                  <p><strong>Início:</strong> {dateFormat(delegation.StartDate)}</p>                  
                  <p><strong>Fim:</strong> {dateFormat(delegation.EndDate)}</p>                  
                </Card.Description>
              </Card.Content>
              { moment(delegation.StartDate).isAfter(moment().add(-1, 'day').endOf('day')) && <Card.Content extra>
                <Button size='mini' color='red' icon onClick={() => this.showConfirm(delegation, 'remove') }>
                  <Icon name='cancel' />
                  Excluir
                </Button>
              </Card.Content> }
            </Card>
          }) }
        </Card.Group>

        <PaginationContainer registers={delegations} onPageChange={(e, { activePage }) => this.handlePageChange(activePage) } />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { delegation, users } = state;  
  return {  
    delegations: delegation || [],
    loading: delegation?.loading,
    me: users.me || null
  };
}

const connectedDelegationScreen = connect(mapStateToProps)(DelegationScreen);
export { connectedDelegationScreen as DelegationScreen };
